var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Top'),_c('div',{attrs:{"id":"app-content"}},[_c('router-view')],1),_c('Footer',{attrs:{"siteList":_vm.siteList}}),_c('RightNav',{attrs:{"siteList":_vm.siteList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }